import { render, staticRenderFns } from "./transactionView.vue?vue&type=template&id=aed1d65c&"
import script from "./transactionView.vue?vue&type=script&lang=js&"
export * from "./transactionView.vue?vue&type=script&lang=js&"
import style0 from "./transactionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports